// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "staged_turn_operation".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "staged_turn_operation" table (1:1 with a DB row, on the wire). */
export const stagedTurnOperationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    conversationId: z.string(),
    operationId: z.string(),
    kind: z.string(),
    status: z.string(),
    data: z.unknown().nullable(),
    claimedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=stagedTurnOperation.js.map